module.exports = __webpack_public_path__ + "media/piranha-plant.996e4757.wav";